import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config/api';
import LoadingSpinner from '../components/LoadingSpinner';

const AttualitaPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(8);

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const response = await axios.get(`${API}/attualita?limit=100`);
        setItems(response.data);
      } catch (error) {
        console.error('Error fetching attualita:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
  }, []);

  if (loading) return <LoadingSpinner />;

  const visibleItems = items.slice(0, visibleCount);
  const hasMore = visibleCount < items.length;

  return (
    <div className="bg-white min-h-screen" data-testid="attualita-page">
      {/* Header - Travera style centered */}
      <div className="py-10 md:py-16">
        <div className="container-custom px-4">
          <h1 className="font-display text-3xl md:text-4xl font-bold text-[#0a1628] text-center" data-testid="attualita-title">Archivio articoli</h1>
        </div>
      </div>

      {/* Grid of cards - Travera style */}
      <div className="container-custom px-4 py-8 md:py-12">
        {items.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-[#64748b] text-lg">Nessun contenuto disponibile</p>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="attualita-grid">
              {visibleItems.map((item) => (
                <a
                  key={`${item.type}-${item.id}`}
                  href={item.link}
                  className="group block"
                  data-testid={`attualita-card-${item.id}`}
                >
                  {item.image_url ? (
                    <div className="overflow-hidden rounded-lg">
                      <img
                        src={item.image_url}
                        alt={item.title}
                        className="w-full h-48 md:h-52 object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                  ) : (
                    <div className="w-full h-48 md:h-52 bg-gray-100 rounded-lg flex items-center justify-center">
                      <span className="text-gray-400 text-sm">Nessuna foto</span>
                    </div>
                  )}
                  <div className="mt-3">
                    <p className="text-[#64748b] text-xs">
                      {item.date ? formatDate(item.date) : ''}
                    </p>
                    <h3 className="font-display text-base font-bold text-[#0a1628] group-hover:text-[#0a7e8c] transition-colors leading-snug mt-1">
                      {item.title}
                    </h3>
                    <p className="text-[#64748b] text-sm mt-2 line-clamp-3 leading-relaxed">
                      {item.excerpt}
                    </p>
                  </div>
                </a>
              ))}
            </div>

            {/* Load more button - Travera style */}
            {hasMore && (
              <div className="text-center mt-10 md:mt-14">
                <button
                  onClick={() => setVisibleCount(prev => prev + 8)}
                  className="inline-block bg-[#0a8a8a] text-white px-8 py-3 font-medium hover:bg-[#087878] transition-colors rounded"
                  data-testid="load-more-btn"
                >
                  Mostra altre notizie
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

function formatDate(dateStr) {
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('it-IT', {
      day: 'numeric', month: 'long', year: 'numeric'
    });
  } catch {
    return '';
  }
}

export default AttualitaPage;
